var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoTourIconBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "object_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M416.78,0H95.22C42.657,0.061,0.061,42.657,0,95.22v321.56c0.061,52.563,42.657,95.159,95.22,95.22h321.56     c52.563-0.061,95.159-42.657,95.22-95.22V95.22C511.939,42.657,469.343,0.061,416.78,0z M476.655,95.22v30.871h-89.539     l-66.966-90.746h96.631C449.833,35.382,476.618,62.167,476.655,95.22z M276.222,35.345l66.966,90.746H235.778l-66.966-90.746     H276.222z M35.345,95.22c0.037-33.052,26.822-59.837,59.875-59.875h29.665l66.966,90.746H35.345V95.22z M416.78,476.655H95.22     c-33.052-0.037-59.837-26.822-59.875-59.875V161.437h441.31V416.78C476.617,449.832,449.832,476.617,416.78,476.655z",
    fill: "#5555FF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350.289,303.74l-139.815-80.722c-8.453-4.88-19.261-1.984-24.141,6.469c-1.551,2.687-2.368,5.734-2.368,8.837v161.445     c0,9.76,7.912,17.673,17.672,17.673c3.102,0,6.15-0.816,8.837-2.368l139.815-80.723c8.453-4.88,11.349-15.688,6.469-24.141     C355.206,307.522,352.975,305.291,350.289,303.74L350.289,303.74z M219.31,369.159V268.933l86.798,50.112L219.31,369.159z",
    fill: "#5555FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoTourIconBlue);
export default __webpack_public_path__ + "static/media/VideoTourIconBlue.2ef5bc39d3e4e3137d57c0bb00ab2d50.svg";
export { ForwardRef as ReactComponent };